import { isInsideIFrame } from '../utils/iframe';
const defaultConfiguration = {
    debug: false,
    defaultDataAttributes: {
        languageCodename: undefined,
        projectId: undefined,
    },
    forceWebSpotlightMode: false,
    isInsideWebSpotlight: false,
    queryParam: 'ksl-enabled',
};
export class ConfigurationManager {
    constructor() {
        this.update = (configuration = {}) => {
            this.configuration = Object.assign(Object.assign({}, this.configuration), configuration);
        };
        this.configuration = defaultConfiguration;
    }
    get debug() {
        return this.configuration.debug;
    }
    get queryParam() {
        return this.configuration.queryParam;
    }
    get defaultLanguageCodename() {
        return this.configuration.defaultDataAttributes.languageCodename;
    }
    get defaultProjectId() {
        return this.configuration.defaultDataAttributes.projectId;
    }
    get isInsideWebSpotlightPreviewIFrame() {
        const { forceWebSpotlightMode, isInsideWebSpotlight } = this.configuration;
        return forceWebSpotlightMode || (isInsideIFrame() && isInsideWebSpotlight);
    }
    static getInstance() {
        if (!ConfigurationManager.instance) {
            ConfigurationManager.instance = new ConfigurationManager();
        }
        return ConfigurationManager.instance;
    }
}
//# sourceMappingURL=ConfigurationManager.js.map